import Swiper from "swiper";
import { find } from "../utils/dom"
export default function Blog(){
	const Page = find("[js-page='blog']")
	if (!Page) return

    // swiper-filter-autores
    let swiperAutores = new Swiper('.swiper-filter-blog',{
        slidesPerView: 'auto',
        spaceBetween:8
    })
}